import "core-js";
import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import App from "./App";
import { register, serviceWorkerConfig } from "./ServiceWorkerConfig";

Sentry.init({
  dsn: "https://185e83bc311443e9a417c990520e2320@sentry.io/5183085",
});

const flipkCss = [
  "background: #5a52c3",
  "color: white",
  "font-size: 9em",
  "padding: 0 80px",
];
const textCss = ["color: #5a52c3", "font-size: 1em", "margin-bottom: 23px"];
console.log("%cKahun", flipkCss.join(";"));
console.log(
  "%cWelcome to Kahun this site was created to share known medical " +
    "knowledge in a graphical way to help doctors make the right decisions and" +
    " don't miss rear cases. We always seek for new engineers to come and help us " +
    "in mapping and modeling the entire medical knowledge to save the world. " +
    "read more on open opportunities at http://kahun.com/ ",
  +" USING MUI - V5 ",
  textCss.join(";"),
);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
register();
serviceWorkerConfig();
